import { Card, Col } from 'react-bootstrap';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { COLOR, STYLE } from '../../../config/constraits';
import { useNavigate } from 'react-router-dom';
import { addFilter, saveBeforeFilter } from '../../../redux/filtersSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useCurrentClient } from '../../auth/api/getCurrentClient';
import { useTranslation } from 'react-i18next';
import ChartShareActions from '../../../components/ChartShareActions';
import { useRef } from 'react';
import { RootState } from '../../../redux/store';

interface FeelingGlobalProps {
    positivePercentage: number,
    neutralPercentage: number;
    negativePercentage: number;
}
export default function FeelingGlobal({ positivePercentage, neutralPercentage, negativePercentage }: FeelingGlobalProps) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation('dashboard');

    const { data: currentClient } = useCurrentClient();

    const feelingchartRef = useRef<HTMLDivElement>(null);

    const total = positivePercentage + neutralPercentage + negativePercentage;
    if ((total != 100) && (total != 0)) {
        negativePercentage = 100 - positivePercentage - neutralPercentage;

    }
    const isEmptyData = positivePercentage + neutralPercentage + negativePercentage === 0;
    const ChartData = isEmptyData
        ? [
            { name: t("dashboard:dashboardDistributionComment1"), value: 100, fixedValue: '0', color: '#BFBFBF' }, // Gris
            { name: t("dashboard:dashboardDistributionComment2"), value: 100, fixedValue: '0', color: '#BFBFBF' }, // Gris
            { name: t("dashboard:dashboardDistributionComment3"), value: 100, fixedValue: '0', color: '#BFBFBF' }, // Gris
        ]
        : [
            { name: t("dashboard:dashboardDistributionComment1"), value: positivePercentage, fixedValue: positivePercentage.toFixed(), color: COLOR.VERD },
            { name: t("dashboard:dashboardDistributionComment2"), value: neutralPercentage, fixedValue: neutralPercentage.toFixed(), color: COLOR.TARONJA },
            { name: t("dashboard:dashboardDistributionComment3"), value: negativePercentage, fixedValue: negativePercentage.toFixed(), color: COLOR.VERMELL },
        ];

    const handleSegmentClick = (sentiment: string) => {
        if (isEmptyData) return;
        // Redirige a la página de "historic" con el tipo de sentimiento como parámetro
        let values: number[] = [];
        switch (sentiment) {
            case 'Sentiment positiu':
                // Valores de 0 hasta el "positiveReference" (sin incluirlo)
                values = Array.from({ length: 5 - (currentClient?.positiveReference || 0) }, (_, i) => i + (currentClient?.positiveReference || 0) + 1);
                break;
            case 'Sentiment neutre':
                // Valores entre "neutralReference" y "positiveReference" (incluye neutralReference, excluye positiveReference)
                if (currentClient?.neutralReference !== undefined && currentClient?.positiveReference !== undefined) {
                    values = Array.from({ length: currentClient?.positiveReference - currentClient?.neutralReference }, (_, i) => i + currentClient?.neutralReference);
                }
                break;
            case 'Sentiment negatiu':
                // Valores de 0 hasta el "neutralReference" (sin incluirlo)
                values = Array.from({ length: (currentClient?.neutralReference || 0) }, (_, i) => i);
                break;
            default:
                break;
        }
        const filter = {
            name: 'SentimentAI',
            values: values.map(String)
        };
        dispatch(saveBeforeFilter('dashboard'));
        dispatch(addFilter({ table: 'dashboard', filter: filter }));
        navigate(`/survey-patient/historic`);
    };

    const selectedFilters = useSelector((state: RootState) => state.filters.dashboard.selectedFilters);

    return (
        <div ref={feelingchartRef}>
        <Card
            style={{
                backgroundColor: "#F5F5F5",
                border: "none",
                borderRadius: STYLE.BORDER_RADIUS,
            }}
                className="p-4 d-flex justify-content-center text-center card"
        >
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4>{t("dashboard:dashboardDistribution")}</h4>
                <ChartShareActions
                    chartRef={feelingchartRef}
                    title={t("dashboard:dashboardDistribution")}
                    filters={selectedFilters}
                    t={t}
                />
            </div>
            <ResponsiveContainer width="100%" height={280} >
                <PieChart width={200} height={200}>
                    <Pie data={ChartData} dataKey="value" nameKey="name" innerRadius={84} outerRadius={120} startAngle={90} endAngle={-270} fill="#82ca9d" onClick={({ name }) => handleSegmentClick(name)}>
                        {ChartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} style={{ cursor: "pointer" }} />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
            <Col className="d-flex justify-content-center">
                <div>
                    {ChartData.map((item, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                            <span className="rounded-circle" style={{ width: '10px', height: '10px', display: 'inline-block', marginRight: '8px', backgroundColor: item.color }}></span>
                            <p style={{ margin: 0 }} key={index}>{item.name}: {item.fixedValue}%</p>
                        </div>
                    ))}
                </div>
            </Col>
            </Card>
        </div>
    );
}
